import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo/logo.png";

const Footer = () => {
	return (
		<footer className="site-footer">
			<div className="site-container footer-grid">
				<div className="footer-brand">
					<img src={logo} alt="NY Engineering" />
					<p>Licensed structural engineering services with a focus on safety, code compliance, and successful project outcomes.</p>
				</div>
				<div>
					<h4><Link to="/services">Services</Link></h4>
					<ul>
						<li>Residential Structural Engineering</li>
						<li>Steel Design</li>
						<li>Seismic Retrofit Design</li>
						<li>Foundation Design</li>
						<li>Retaining Wall Design</li>
						<li>Commercial Engineering</li>
					</ul>
					<div className="footer-service-areas">
						<h4>Service Areas</h4>
						<p>California & New York</p>
					</div>
				</div>
				<div>
					<h4><Link to="/about#licenses-certifications">Credentials</Link></h4>
					<ul>
						<li>California PE License #68482</li>
						<li>New York PE License #101584</li>
						<li>GSA Award Engineer</li>
						<li>LBE / WBE / WOSB / WBENC</li>
					</ul>
				</div>
				<div>
					<h4><Link to="/contact">Contact</Link></h4>
					<p><a href="tel:+14155681270">1-(415)-568-1270</a></p>
					<p><a href="mailto:nyengineering@sbcglobal.net">nyengineering@sbcglobal.net</a></p>
					<p className="footer-address"><span>Mailing Address</span><br />850 S. Van Ness Ave<br />San Francisco, CA 94110</p>
					<p className="footer-address"><span>Office Address</span><br />3601 Taraval Street<br />San Francisco, CA 94116</p>
				</div>
			</div>
			<div className="footer-bottom site-container">
				<span>© 2026 NY Engineering. All rights reserved.</span>
			</div>
		</footer>
	);
};

export default Footer;
